import { createContext, useContext, useState } from "react";

const BillContext = createContext();

export const BillProvider = ({ children }) => {
  const [bill, setBill] = useState(null);
  const [loading, setLoading] = useState(false); // ✅ added

  return (
    <BillContext.Provider
      value={{
        bill,
        setBill,
        loading,
        setLoading,
      }}
    >
      {children}
    </BillContext.Provider>
  );
};

export const useBill = () => useContext(BillContext);
